import { priceChangePercent, type Product } from '@pricymayky/shared';

export type ProductSort = 'updated' | 'name' | 'price-asc' | 'price-desc' | 'change';

export function filterAndSortProducts(products: Product[], search: string, categoryId: string, sort: ProductSort): Product[] {
  const normalized = search.trim().toLocaleLowerCase('pl-PL');
  const filtered = products.filter((product) => {
    const matchesSearch = !normalized || [product.name, product.category.name, ...product.offers.map((offer) => offer.store.name)].some((value) => value.toLocaleLowerCase('pl-PL').includes(normalized));
    return matchesSearch && (!categoryId || product.category.id === categoryId);
  });
  return filtered.toSorted((left, right) => {
    const leftOffer = left.offers[0]!;
    const rightOffer = right.offers[0]!;
    if (sort === 'name') return left.name.localeCompare(right.name, 'pl');
    if (sort === 'price-asc') return leftOffer.currentPriceMinor - rightOffer.currentPriceMinor;
    if (sort === 'price-desc') return rightOffer.currentPriceMinor - leftOffer.currentPriceMinor;
    if (sort === 'change') return (priceChangePercent(leftOffer.currentPriceMinor, leftOffer.previousPriceMinor) ?? 0) - (priceChangePercent(rightOffer.currentPriceMinor, rightOffer.previousPriceMinor) ?? 0);
    return new Date(rightOffer.lastCheckedAt ?? right.createdAt).getTime() - new Date(leftOffer.lastCheckedAt ?? left.createdAt).getTime();
  });
}
